if(typeof AI == "undefined") {
	AI = {};
}

(function (AI) {
	'use strict';

	var download = function() {
		this.download = {};
	};

	download.prototype = {

		cookieName: 'downloadPropFile',

		/**
		 * [init description]
		 * @return {[type]} [description]
		 */
		init: function() {
			this.clickHandlers();
			this.initCookieName();
		},

		/**
		 * [clickHandlers description]
		 * @return {[type]} [description]
		 */
		clickHandlers: function() {
			var self = this;
			jQuery(document).ready(function($) {
				$('.download-file').click(function (event) {
					event.preventDefault();
					self.prepareDownload($(this));
					return false;
				});
			});
		},

		/**
		 * [initCookieName description]
		 * @return {[type]} [description]
		 */
		initCookieName: function () {
			var self = this;
			self.cookieName += '-' + $('#property_source_id').html();
		},

		/**
		 * [prepareDownload description]
		 * @param  {[type]} file [description]
		 * @return {[type]}      [description]
		 */
		prepareDownload: function(file) {
			var self = this,
				cookie_value = self.readCookie(),
				file_id = file.data('file_id');

			if (cookie_value === null) {
				this.launchDownloadRequestModal(file_id);
			} else {
				this.getFileURL(file_id);
			}
		},

        /**
         * [readCookie description]
         * @return {[type]} [description]
         */
        readCookie: function() {
            var nameEQ = this.cookieName + "=",
            	ca = document.cookie.split(';'),
            	i = 0, c;

            for(i = 0;i < ca.length; i++) {
                c = ca[i];
                while (c.charAt(0)==' ') {
                    c = c.substring(1,c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length,c.length);
                }
            }
            return null;
        },

        /**
         * [launchDownloadRequestModal description]
         * @param  {[type]} file_id [description]
         * @return {[type]}         [description]
         */
        launchDownloadRequestModal: function (file_id) {
        	$('#requestFileFormID #file_id').val(file_id);
        	$('#request_file').modal('show');
        },

        getFileURL: function (file_id) {
        	AI.misc.getFile(file_id).done(function(response) {
        		if (response.file_url !== undefined) {
	        		window.open(response.file_url, "_blank");
	        	}
    		});
        }
	};

	AI.download = new download();

})(AI);

AI.download.init();


// WEBPACK FOOTER //
// ./resources/assets/js/ai/download-files.js